/**
 * @module  experience/hardgoods
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

// Modules
import { WidgetsModule } from '@support/shared/widgets/widgets.module';
import { SharedBrowseModule } from '@experience/shop/shared-browse/shared-browse.module';

import { HARDGOODS_ROUTES } from '@experience/shop/hardgoods/hardgoods.routes';
import { BrowseHardgoodsService } from '@experience/shop/hardgoods/services/browse-hardgoods.service';
import { CompareHardgoodsService } from '@experience/shop/hardgoods/services/compare-hardgoods.service';
import { CompareDevicesComponent } from './components/compare-devices/compare-devices.component';
import { HardgoodPriceComponent } from './components/hardgood-price/hardgood-price.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowseDevicesLandingComponent } from '@experience/shop/hardgoods/components/browse-devices-landing-component/browse-devices-landing.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { SearchResultService } from '@experience/search-results/services/search-result.service';
import { AccessoryCategoryDetailsComponent } from '@experience/shop/hardgoods/components/accessory-category-details/accessory-category-details.component';
import { BrowseAccessoryComponent } from '@experience/shop/hardgoods/components/browse-accessory/browse-accessory.component';
import { AemModule } from '@core/aem/aem.module';

@NgModule({
  imports: [
    CommonModule,
    WidgetsModule,
    FormsModule,
    AemModule,
    ReactiveFormsModule,
    RouterModule.forChild(HARDGOODS_ROUTES),
    SharedBrowseModule,
    InfiniteScrollModule,
  ],
  providers: [BrowseHardgoodsService, CompareHardgoodsService, SearchResultService],
  declarations: [
    BrowseDevicesLandingComponent,
    CompareDevicesComponent,
    HardgoodPriceComponent,
    AccessoryCategoryDetailsComponent,
    BrowseAccessoryComponent,
  ],
})
export class HardgoodsModule {}
